// extracted by mini-css-extract-plugin
export default {"wrapper":"shareVideo_wrapper__OiVTV","loadingWrapper":"shareVideo_loadingWrapper__ZW4SN","errorWrapper":"shareVideo_errorWrapper__6lleW","infoList":"shareVideo_infoList__i3Ndx"};